import Icon from '@/components/ui/AppIcon';

export default function TimelineSection() {
  const milestones = [
    {
      id: 'milestone_2001',
      year: '2001',
      title: 'Company Founded',
      description: 'SDSA was born on July 26, 2001 in Oupeye, Belgium. Our vision: become a trusted global supply leader.',
      icon: 'RocketLaunchIcon',
    },
    {
      id: 'milestone_2005',
      year: '2005',
      title: 'First International Partnership',
      description: 'We expanded to the Netherlands, establishing our first cross-border supply network and learning what it takes to serve international clients.',
      icon: 'GlobeAltIcon',
    },
    {
      id: 'milestone_2010',
      year: '2010',
      title: 'Global Expansion',
      description: 'We entered Brazilian and Moroccan markets, tripling our reach and partner base. This was a turning point for our business.',
      icon: 'ArrowTrendingUpIcon',
    },
    {
      id: 'milestone_2015',
      year: '2015',
      title: 'ISO Certification',
      description: 'We achieved ISO certification, proving our commitment to quality standards and excellence. This certification opened new doors.',
      icon: 'ShieldCheckIcon',
    },
    {
      id: 'milestone_2020',
      year: '2020',
      title: '5,000+ Partners Milestone',
      description: 'We reached 5,000 active partnerships worldwide, becoming a trusted name in global supply distribution.',
      icon: 'UsersIcon',
    },
    {
      id: 'milestone_2025',
      year: '2025',
      title: 'Industry Leader',
      description: 'Recognized as a global leader in wholesale supply with operations in 25+ countries. The journey continues.',
      icon: 'TrophyIcon',
    },
  ]

  return (
    <div className="space-y-8">
      {milestones.map((milestone, index) => (
        <div
          key={milestone.id}
          className="flex gap-6 reveal"
          style={{ transitionDelay: `${index * 100}ms` }}
        >
          {/* Year & Icon */}
          <div className="flex-shrink-0 flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center mb-2">
              <Icon name={milestone.icon as any} size={28} className="text-primary-foreground" />
            </div>
            <div className="text-2xl font-bold font-serif text-primary">{milestone.year}</div>
          </div>

          {/* Content */}
          <div className="flex-1 pb-8 border-l-2 border-border pl-6 -ml-px">
            <h3 className="text-xl font-bold font-serif text-foreground mb-2">
              {milestone.title}
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {milestone.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}